import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {post} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";
import {getMsgType, Type} from "../Transaction/helper";

function getUrl(request) {
    switch (request.type) {
        case Type.sale_invoice:
            return '/shoebox/invoices';
        case Type.purchase_bill:
            return '/shoebox/bills';
        case Type.purchase_credit_note:
            return '/shoebox/purchases/credit_notes';
        case Type.bank_income:
            return '/shoebox/incomes';
        case Type.bank_expense:
            return '/shoebox/expenses';
        default:
            throw new Error(`Unknown type ${request.type}`);
    }
}

// Create
export function* createRequest() {
    yield takeEvery(actions.SHOEBOX_TRANSACTION_CREATE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            context.allow_intercept = true;
            yield call(post, getUrl(request), request, context);

            // OK
            yield put({
                type: actions.SHOEBOX_TRANSACTION_CREATE_SUCCESS,
                transactionType: request.type,
            });

            yield message.success(t`The ${getMsgType(request.type)} is created.`);
        }
        catch (error) {
            yield put({
                type: actions.SHOEBOX_TRANSACTION_CREATE_ERROR,
                error,
            });

            const code = error.statusCode;
            const isInterceptCodes = code === 428 || code === 412;
            if (!isInterceptCodes)
                yield message.error(error.message);
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(createRequest),
    ]);
}
